import React, { useState } from "react";
import { examDuration } from "../constant/Constants";

const EducatorAccordionPage = () => {
  const [active, setActive] = useState(1);
  const handleActive = (index) => {
    setActive((prev) => (prev === index ? 0 : index));
  };

  const faqDataFull = [
    {
      id: "One",
      ariaExpanded: "true",
      title: "Does Practido offer mathematics Olympiad questions for classroom use?",
      content: `Absolutely. Practido’s <b>question bank</b> includes a wide range of mathematics olympiad questions designed for classroom teaching, explanation material justifying each answer, and competitive exam prep. Whether you need higher-order problem-solving questions or level-based practice, you’ll find structured sets ready to use—and you can even customize them to match your class strategy.`,
    },
    {
      id: "Two",
      ariaExpanded: "false",
      title: "How does Practido support teachers in improving student learning outcomes?",
      content:
        "Practido gives teachers a complete ecosystem, not just a <b>question bank</b>. You get real-time dashboards, detailed performance analytics, AI-powered question creation, topic-level insights, and engaging add-ons like science games that boost understanding.",
    },
    {
      id: "Three",
      ariaExpanded: "false",
      title: "Where can I find reliable math Olympiad questions for my students?",
      content:
        "Practido offers one of the most reliable and well-structured collections of <u>math Olympiad questions</u> inside its smart <b>question bank</b> of our Practido Olympiad Practice App and Practido AI teacher module. You can browse pre-built sets, generate your own using AI, or instantly create a <u>math practice exam</u> based on difficulty level. Whether you're training beginners or advanced Olympiad aspirants, Practido has the variety you need.",
    },
    {
      id: "Four",
      ariaExpanded: "false",
      title: "Is Practido helpful for Olympiad coaching in schools?",
      content:
        "100%. Practido is built for schools that want to strengthen their Olympiad prep. From high-quality <u>mathematics olympiad questions</u> to science tests, English quizzes, computer-based assessments, and interactive <u>science games</u>, the platform supports schools in delivering consistent, competitive training with less workload on teachers.",
    },
    {
      id: "Five",
      ariaExpanded: "false",
      title: "How to train students for Science Olympiad?",
      content:
        `The smartest way is through consistent, concept-focused practice, and Practido makes that easy. Teachers can create targeted science tests, use subject-specific modules, add interactive <u>science games</u>, monitor performance in real time, and track topic-wise weaknesses. 
        `,
    }
    
  ];
  return (
    <div className="accordion" id="accordiondata">
      {faqDataFull?.map(({ id, ariaExpanded, title, content }, index) => (
        <div
          className={`card ${active === index + 1 ? "active" : ""}`}
          key={id}
        >
          <div className="card-header" id={`heading${id}`}>
            <button
              className={`btn-link btn-block text-left ${
                ariaExpanded !== "true" ? "collapsed" : ""
              }`}
              type="button"
              data-toggle="collapse"
              data-target={`#collapse${id}`}
              aria-expanded={ariaExpanded}
              aria-controls={`collapse${id}`}
              onClick={() => handleActive(index + 1)}
            >
              {title}
            </button>
          </div>
          <div
            id={`collapse${id}`}
            className={`collapse ${ariaExpanded === "true" ? "show" : ""}`}
            aria-labelledby={`heading${id}`}
            data-parent="#accordiondata"
          >
            <div
              className="card-body"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EducatorAccordionPage;
